import React, { useEffect, useState, useMemo, useCallback } from 'react';
// import styled from 'styled-components';
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
  Badge,
  Input,
} from 'reactstrap';
import 'react-calendar/dist/Calendar.css';
import { Calendar } from 'react-calendar';
import {
  FaArrowCircleRight,
  FaArrowRight,
  FaEdit,
  FaEye,
  FaPlus,
  FaSearch,
  FaTrash,
} from 'react-icons/fa';
import { CalendarLocal } from '../components/CalendarLocal';
import { ModalAddEvent } from '../components/modalAddEvent/index';
import { useEvent } from './../../hooks/useEvent';
import Loading from 'react-loading';
import SearchBar from '../components/searchBar';
import { apiAp } from './../../services/apiAmapá';
import { api } from './../../services/api';
import axios from 'axios';
import { TablePadrão } from './../components/table/index';
import { ModalEditUser } from '../components/modalEditUser';
import { toast } from 'react-toastify';
import { ModalEditCompany } from '../components/modalEditCompany';

interface CompanyTypeEdit {
  id: string;
  name: string;
  cnpj: string;
  email: string;
  phone: string;
  street: string;
  number: string;
  neighborhood: string;
  city: string;
  state: string;
  status: string;
  is_active: boolean;
}

export function Company(): React.JSX.Element {
  const [inputAdded, setInputAdded] = useState('');
  const [inputNotAdded, setInputNotAdded] = useState('');
  const [companyDefault, setCompanyDefault] = useState<CompanyTypeEdit[]>([]);
  const [company, setCompany] = useState<CompanyTypeEdit[]>([]);
  const [selected, setSelected] = useState<CompanyTypeEdit>();
  const [firstTab, setFirstTab] = useState(true);
  const [secondTab, setSecondTab] = useState(false);
  const [thirdTab, setThirdTab] = useState(false);
  const [fourthTab, setFourthTab] = useState(false);
  const [currentStatus, setCurrentStatus] = useState(null);

  const [loading, setLoading] = useState(false);
  const [loadingLocal, setLoadingLocal] = useState(true);

  const [loadingSearch, setLoadingSearch] = useState(false);
  const [septemberDays, setSeptemberDays] = useState<Date[]>([]);
  const [isOpenModalUser, setIsOpenModalUser] = useState(false);
  const [inputNameOrCNPJ, setInputNameOrCNPJ] = useState(null);

  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);

  function handleIsOpenModalUser(): void {
    setIsOpenModalUser(!isOpenModalUser);
  }

  function localUserHandleOpenModal(item: CompanyTypeEdit): void {
    setSelected(item);
    handleIsOpenModalUser();
  }

  // const findTicketsPerPage = useCallback(
  //   async (targetPage: number) => {
  //     setLoading(true);
  //     setInputNameOrCPF('');
  //     try {
  //       let response;
  //       if (currentStatus) {
  //         response = await api.get('ticket', {
  //           params: {
  //             page: targetPage,
  //             perPage,
  //             paginated: true,
  //             status: currentStatus,
  //           },
  //         });
  //       } else {
  //         response = await api.get('ticket', {
  //           params: {
  //             page: targetPage,
  //             perPage,
  //             paginated: true,
  //           },
  //         });
  //       }

  //       setTickets(response.data.tickets);

  //       setTicketsDefault(response.data.tickets);

  //       setPage(response.data.page);
  //       setTotalPages(response.data.totalPage);
  //       setLoading(false);
  //     } catch (err) {
  //       console.log(err);
  //       const message = 'Ocorreu um erro ao buscar os dados do cupom';
  //       setLoading(false);
  //       toast(message, {
  //         type: 'error',
  //       });
  //     }
  //   },
  //   [currentStatus],
  // );
  async function findCompaniesPerPage(targetPage: number): Promise<void> {
    setLoading(true);
    setInputNameOrCNPJ('');
    try {
      let response;

      if (currentStatus) {
        response = await api.get('company', {
          params: {
            page: targetPage,
            perPage,
            paginated: true,
            is_active: currentStatus !== 'Inativos',
          },
        });
      } else {
        response = await api.get('company', {
          params: {
            page: targetPage,
            perPage,
            paginated: true,
          },
        });
      }
      setCompany(response.data.companies);

      setCompanyDefault(response.data.companies);

      setPage(response.data.page);
      setTotalPages(response.data.totalPage);

      setLoading(false);
      setLoadingLocal(false);
    } catch (err) {
      const message = 'Ocorreu um erro ao buscar os dados da empresa';
      setLoading(false);
      toast(message, {
        type: 'error',
      });
    }
  }

  useEffect(() => {
    findCompaniesPerPage(1)
      .then(() => {})
      .catch((err) => {
        console.log(err);
      });
  }, [perPage]);

  // useEffect(() => {
  //   setLoadingLocal(false);
  // }, [tickets]);

  async function filter(): Promise<void> {
    setLoadingLocal(true);

    if (inputNameOrCNPJ?.length === 0) {
      await findCompaniesPerPage(1);
    } else {
      try {
        const response = await api.get(`company/search/${String(inputNameOrCNPJ)}`);
        setCompany(response.data);
        setLoadingLocal(false);
      } catch (error) {
        console.log(error);
        setLoadingLocal(false);
      }
    }
  }
  useEffect(() => {
    if (inputNameOrCNPJ !== null) {
      const handler = setTimeout(() => {
        filter().catch((err) => {
          console.log(err);
        });
      }, 500); // debounce de 500ms

      return () => {
        clearTimeout(handler); // limpa timeout anterior se inputNameOrCNPJ mudar rápido
      };
    }
  }, [inputNameOrCNPJ]);

  // const thead = ['Nome', 'Endereço', 'Telefone', 'Status', 'Ações'];
  // const headWidth = ['25%', '25%', '20%', '20%', '10%'];

  const thead = ['CNPJ', 'Nome do dono', 'Telefone', 'Status', 'Ações'];
  const headWidth = ['30%', '20%', '20%', '20%', '10%'];

  useEffect(() => {
    if (currentStatus !== null) {
      findCompaniesPerPage(1)
        .then(() => {})
        .catch((err) => {
          console.log(err);
        });
    }
  }, [currentStatus]);

  async function handleChangeTabs(tabNumber: number): Promise<void> {
    switch (tabNumber) {
      case 1:
        setFirstTab(true);
        setSecondTab(false);
        setThirdTab(false);
        setCurrentStatus('');
        break;
      case 2:
        setFirstTab(false);
        setSecondTab(true);
        setThirdTab(false);
        setCurrentStatus('Ativos');
        break;
      case 3:
        setFirstTab(false);
        setSecondTab(false);
        setThirdTab(true);
        setCurrentStatus('Inativos');
        break;
      default:
        break;
    }
  }
  // <div style={{ width: '100%', backgroundColor: '#F2F2F2' }}>

  return (
    <div style={{ width: '100%', backgroundColor: '#FFF', minHeight: '90vh' }}>
      {loading ? (
        <div
          style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 25 }}
        >
          <Loading width={30} color={'#005675'} type={'spin'} />
        </div>
      ) : (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            marginLeft: 50,
            marginTop: 40,
            marginRight: 50,
          }}
        >
          <div className="col-sm-4" style={{ display: 'flex', marginBottom: 15, marginTop: 15 }}>
            <h4>Empresas</h4>
          </div>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div
              style={{
                display: 'flex',
                backgroundColor: firstTab ? '#FFF' : '#F5F5F5',
                border: '1px solid rgba(0, 0, 0, 0.05)',
                width: 100,
                borderBottom: 'none',
                borderTopRightRadius: 8,
                borderTopLeftRadius: 8,
                height: 30,
                justifyContent: 'center',
                alignItems: 'center',
                position: firstTab ? 'relative' : 'static',
                top: 1,
                cursor: 'pointer',
              }}
              onClick={() => {
                void handleChangeTabs(1);
              }}
            >
              <span>Todos</span>
            </div>
            <div
              style={{
                display: 'flex',
                backgroundColor: secondTab ? '#FFF' : '#F5F5F5',
                border: '1px solid rgba(0, 0, 0, 0.05)',
                width: 100,
                borderBottom: 'none',
                borderTopRightRadius: 8,
                borderTopLeftRadius: 8,
                height: 30,
                justifyContent: 'center',
                alignItems: 'center',
                position: secondTab ? 'relative' : 'static',
                top: 1,
                cursor: 'pointer',
              }}
              onClick={() => {
                void handleChangeTabs(2);
              }}
            >
              <span>Ativos</span>
            </div>
            <div
              style={{
                display: 'flex',
                backgroundColor: thirdTab ? '#FFF' : '#F5F5F5',
                border: '1px solid rgba(0, 0, 0, 0.05)',
                width: 100,
                borderBottom: 'none',
                borderTopRightRadius: 8,
                borderTopLeftRadius: 8,
                height: 30,
                justifyContent: 'center',
                alignItems: 'center',
                position: thirdTab ? 'relative' : 'static',
                top: 1,
                cursor: 'pointer',
              }}
              onClick={() => {
                void handleChangeTabs(3);
              }}
            >
              <span>Inativos</span>
            </div>
          </div>

          <div style={{ border: '1px solid rgba(0, 0, 0, 0.05)' }}>
            <div className="d-flex justify-content-between flex-column flex-md-row p-3 gap-4">
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 50,
                  flex: 1,
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: 15,
                    marginTop: 0,
                  }}
                >
                  <span>Mostrar</span>
                  <Input
                    type="select"
                    onChange={(e) => {
                      setPerPage(Number(e.target.value));
                    }}
                    style={{ width: 80, marginRight: 8, marginLeft: 8 }}
                    value={perPage}
                  >
                    <option key={'10'} value={'10'}>
                      10
                    </option>
                    <option key={'20'} value={'20'}>
                      20
                    </option>
                    <option key={'30'} value={'30'}>
                      30
                    </option>
                  </Input>
                  <span>registros</span>
                </div>
                <div
                  className="col-sm-4"
                  style={{
                    display: 'flex',
                    marginBottom: 15,
                    flexDirection: 'column',
                  }}
                >
                  <Input
                    value={inputNameOrCNPJ}
                    onChange={(e) => {
                      // eslint-disable-next-line @typescript-eslint/no-floating-promises
                      setInputNameOrCNPJ(e.target.value);
                    }}
                    placeholder={'Pesquise por nome ou CNPJ da empresa'}
                  />

                  {/* <p style={{ fontSize: 14, marginTop: 5 }}>{'(Insira pelo menos 4 caracteres)*'}</p> */}
                </div>
              </div>{' '}
            </div>
            <br />
            {loadingLocal ? (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginTop: 25,
                }}
              >
                <Loading width={30} color={'#005675'} type={'spin'} />
              </div>
            ) : company?.length === 0 && !loadingLocal ? (
              <div className="c-text-danger d-flex justify-content-center mt-20">
                Nenhuma empresa encontrada.
              </div>
            ) : (
              <TablePadrão
                page={page}
                totalPage={totalPages}
                thead={thead}
                headWidth={headWidth}
                // eslint-disable-next-line @typescript-eslint/no-misused-promises
                handleChangePage={findCompaniesPerPage}
              >
                {company?.map((item, i) => {
                  // Encontra o dono da empresa no array userCompanies
                  // @ts-expect-error
                  const owner = item?.UserCompany?.find((uc) => uc.owner === true);
                  console.log(owner, item);
                  return (
                    <tr
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        backgroundColor: i % 2 === 0 ? '#F5F9FF' : '#FFF',
                        padding: 10,
                      }}
                      key={item?.id}
                    >
                      <td
                        style={{
                          width: '30%',
                          justifyContent: 'start',
                          textAlign: 'start',
                          marginLeft: 10,
                        }}
                      >
                        {item?.name}
                      </td>
                      <td
                        style={{
                          width: '20%',
                          justifyContent: 'start',
                          textAlign: 'center',
                        }}
                      >
                        {owner ? owner.user.name : 'Sem dono'}
                      </td>
                      <td style={{ width: '20%', textAlign: 'center' }}>{item?.phone}</td>
                      <td style={{ width: '20%', textAlign: 'center' }}>
                        {item?.is_active && (
                          <Badge className="col-sm-5" color="success">
                            Ativo
                          </Badge>
                        )}
                        {!item?.is_active && (
                          <Badge className="col-sm-5" color="danger">
                            Inativo
                          </Badge>
                        )}
                      </td>
                      <td style={{ width: '10%', textAlign: 'center' }}>
                        <FaEdit
                          color="#0D6EFD"
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            localUserHandleOpenModal(item);
                          }}
                        />
                      </td>
                    </tr>
                  );
                })}
              </TablePadrão>
            )}
          </div>
        </div>
      )}
      {selected && (
        <ModalEditCompany
          // eslint-disable-next-line @typescript-eslint/no-misused-promises
          getAllUsers={findCompaniesPerPage}
          company={selected}
          handleIsOpen={handleIsOpenModalUser}
          isOpen={isOpenModalUser}
        />
      )}
    </div>
  );
}

// const WrapperContainer = styled.div`
//   width: 100%;

//   .content {
//     width: 100%;

//     & div {
//       display: flex;
//     }

//     select:focus {
//       outline: none;
//     }

//     textarea:focus {
//       outline: none;
//     }

//     & input {
//       width: 100%;
//     }

//     & input:focus {
//       outline: none !important;
//     }

//     .inputfile {
//       width: 0.1px;
//       height: 0.1px;
//       opacity: 0;
//       overflow: hidden;
//       position: absolute;
//       z-index: -1;
//     }
//     .inputfile:focus + label {
//       outline: 1px dotted #000;
//       outline: -webkit-focus-ring-color auto 5px;
//     }
//     .inputfile + label * {
//       pointer-events: none;
//     }
//   }
// `;
